import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const KhodroApiPaths: IPaths = {
  BimehNamehHayeShakhsSales: {
    PrintBimehNamehShakhsSales: 'BimehNamehHayeShakhsSales/PrintBimehNamehShakhsSales',
    PrintElhaghiyehShakhsSales: 'BimehNamehHayeShakhsSales/PrintElhaghiyehShakhsSales',
    PrintBimehNamehShakhsSalesById: 'BimehNamehHayeShakhsSales/PrintBimehNamehShakhsSalesById',
    GetPrintBimehNamehShakhsSalesDisplay: 'BimehNamehHayeShakhsSales/GetPrintBimehNamehShakhsSalesDisplay',
    GetAllShakhsSalesShomarehBimehNamehHa: 'BimehNamehHayeShakhsSales/GetAllShakhsSalesShomarehBimehNamehHa',
    EstelamShakhsSales: 'BimehNamehHayeShakhsSales/EstelamShakhsSales',
    CreateShenasehPardakhtWithPelak: 'BimehNamehHayeShakhsSales/CreateShenasehPardakhtWithPelak',
    CreateShenasehPardakhtWithoutPelak: 'BimehNamehHayeShakhsSales/CreateShenasehPardakhtWithoutPelak',
    CreateShenasehPardakhtChangePelak: 'BimehNamehHayeShakhsSales/CreateShenasehPardakhtChangePelak',
    GetAllShakhsSalesBimehNamehHaPagedFilter: 'BimehNamehHayeShakhsSales/GetAllShakhSalesBimehNamehHaPagedFilter',
    GetShakhsSalesBimehNamehByShomarehBimehNameh:
      'BimehNamehHayeShakhsSales/GetShakhsSalesBimehNamehByShomarehBimehNameh',
    GetAllShakhSalesBimehNamehHaGrid: 'BimehNamehHayeShakhsSales/GetAllShakhSalesBimehNamehHaGrid',
    AddToOrder: 'BimehNamehHayeShakhsSales/AddBimehNamehShakhsSalesToOrderWepod',
    BimehNamehShakhsSalesSaderShodeh: 'BimehNamehHayeShakhsSales/BimehNamehShakhsSalesSaderShodeh',
    GetBimehNamehShakhsSalesExpireDateMaxDay: 'BimehNamehHayeShakhsSales/GetBimehNamehShakhsSalesExpireDateMaxDay',
    EstelamMojadadShakhsSalesKhodro: 'BimehNamehHayeShakhsSales/EstelamMojadadShakhsSalesKhodroWepod',
    EstelamSabtAhval: 'BimehNamehHayeShakhsSales/EstelamSabtAhval',
    GetElhaghiyehHayeSadereh: 'BimehNamehHayeShakhsSales/GetElhaghiyehHayeSadereh',
    IsDuplicateBimehNamehShakhsSalesInOrder: 'BimehNamehHayeShakhsSales/IsDuplicateBimehNamehInOrder',
  },
  BimehNamehHayeBadaneh: {
    PrintBimehNamehBadaneh: 'BimehNamehHayeBadaneh/PrintBimehNamehBadaneh',
    GetPrintBimehNamehBadanehDisplay: 'BimehNamehHayeBadaneh/GetPrintBimehNamehBadanehDisplay',
    GetAllBadanehShomarehBimehNamehHa: 'BimehNamehHayeBadaneh/GetAllBadanehShomarehBimehNamehHa',
    EstelamBadaneh: 'BimehNamehHayeBadaneh/EstelamBadaneh',
  },
  MoredEstefadehKhodro: {
    GetAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh:
      'MoredEstefadehKhodro/GetActiveMoredEstefadehHayeKhodroByNoeVasilehNaghliehCoreId',
  },
  NoeVasilehNaghlieh: {
    GetAllAnvaeVasilehNaghleyeh: 'NoeVasilehNaghlieh/GetActiveAnvaeVasilehNaghlieh',
  },
  Brand: {
    GetAllBrandHaByNoeVasilehNaghlieh: 'Brand/GetActiveBrandHaByNoeVasilehNaghliehCoreId',
  },
  Tip: {
    GetAllTipHaByBrandQuery: 'Tip/GetActiveTipHaByBrandCoreId',
  },
  HarfPelak: {
    GetAllHarfHayePelak: 'HarfPelak/GetAllHarfHayePelak',
  },
  AnvaePelak: {
    GetAllAnvaePelakByNoeVasilehNaghlieh: 'AnvaePelak/GetActiveAnvaePelakByNoeVasilehNaghliehCoreId',
    GetSerialHayePelakByHarfPelak: 'AnvaePelak/GetSerialHayePelakByHarfPelak',
  },
  TaahodSalesJaani: {
    GetActiveTaahodSalesJaani: 'TaahodSalesJaani/GetActiveTaahodSalesJaani',
  },
  TaahodSalesMali: {
    GetAllTaahodatSalesMali: 'TaahodSalesMali/GetAllTaahodatSalesMali',
  },
  TakhfifJarimehSales: {
    GetAllTakhfifHayeJarimehSales: 'TakhfifJarimehSales/GetAllTakhfifHayeJarimehSales',
    GetAllTakhfifHayeJarimehSarneshin: 'TakhfifJarimehSales/GetAllTakhfifHayeJarimehSarneshin',
  },
  TaahodSalesSarneshin: {
    GetActiveTaahodSalesSarneshin: 'TaahodSalesSarneshin/GetActiveTaahodSalesSarneshin',
  },
  BimehMarkazi: {
    EstelamBimehMarkazi: 'BimehMarkazi/EstelamBimehNameh',
    EstelamBimehNamehWithShomarehEntezami: 'BimehMarkazi/EstelamBimehNamehWithShomarehEntezami',
    EstelamBimehNamehDetailWithShomarehEntezami: 'BimehMarkazi/EstelamBimehNamehDetailWithShomarehEntezami',
    EstelamWithShomarehBimehNamehAndShomarehEntezami: 'BimehMarkazi/EstelamWithShomarehBimehNamehAndShomarehEntezami',
    EstelamDarsadTakhfif: 'BimehMarkazi/EstelamDarsadTakhfif',
  },
  RangKhodro: {
    GetAllRangHayeKhodro: 'RangKhodro/GetAllRangHayeKhodro',
  },
  NoeGovahinameh: {
    GetAllAnvaeGovahiNameh: 'NoeGovahinameh/GetAllAnvaeGovahiNameh',
  },
  ModatEtebarGovahiNameh: {
    getAllModatEtebarHayeGovahiname: 'ModatEtebarGovahiNameh/GetAllModatEtebarHayeGovahiname',
  },
  SharayetGovahiNameh: {
    getAllSharayetGovahiNameh: 'SharayetGovahiNameh/GetAllSharayetGovahiNameh',
  },
  FeranshizBadaneh: {
    GetAllFeranshizHayeBadaneh: 'FeranshizBadaneh/GetActiveFeranshizHayeBadaneh',
  },
  PoosheshTakmiliBadaneh: {
    GetAllPoosheshHayeTakmiliBadaneh: 'PoosheshTakmiliBadaneh/GetAllPoosheshHayeTakmiliBadaneh',
  },
  GorohPoosheshTakmiliBadaneh: {
    GetAllGorohHayePoosheshTakmiliBadaneh: 'GorohPoosheshTakmiliBadaneh/GetAllGorohHayePoosheshTakmiliBadanehGraph',
  },
  SerialPelak: {
    GetSerialHayePelakByNoePelakCoreId: 'SerialPelak/GetSerialHayePelakByNoePelakCoreId',
    GetAllSerialPelaks: 'SerialPelak/GetAllSerialPelaks',
  },
};
